import { GetStaticProps, NextPage } from 'next'

import PageNotFound from 'Root/Pages/PageNotFound'
import { loadCatalog } from 'lib/i18n'
import { useIsClient } from 'lib/use-is-client'

export const getStaticProps: GetStaticProps = async () => {
  const translation = await loadCatalog('en')

  return {
    props: {
      translation,
    },
  }
}

const Page: NextPage = () => {
  const isClient = useIsClient()

  if (!isClient) return null

  return <PageNotFound />
}

export default Page
